import React, { createContext, useContext, useEffect, useState } from 'react';
import { OFFICIAL_ASSETS, subscribeToBranding } from '../api/brandingService';

const BrandingContext = createContext();
const fallbackBranding = {
  logoUrl: OFFICIAL_ASSETS.logo,
  pwaLogoUrl: OFFICIAL_ASSETS.logo,
  faviconUrl: OFFICIAL_ASSETS.favicon,
  pwa192Url: OFFICIAL_ASSETS.pwa192,
  pwa512Url: OFFICIAL_ASSETS.pwa512,
  maskableUrl: OFFICIAL_ASSETS.maskable,
  ogImageUrl: OFFICIAL_ASSETS.ogImage
};

function updateLink(rel, href) {
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.rel = rel;
    document.head.appendChild(element);
  }
  element.href = href;
}

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(fallbackBranding);

  useEffect(() => {
    const unsubscribe = subscribeToBranding(
      nextBranding => setBranding(nextBranding),
      error => console.error('No se pudo cargar la identidad visual:', error)
    );
    return unsubscribe;
  }, []);

  useEffect(() => {
    updateLink('icon', OFFICIAL_ASSETS.favicon);
    updateLink('apple-touch-icon', branding.logoUrl);
  }, [branding]);

  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>;
}

export function useBranding() {
  return useContext(BrandingContext) || fallbackBranding;
}

